import { z } from 'zod';

/**
 * Schema for item group form data
 */
export const itemGroupSchema = z.object({
  ma_nhom: z.string().min(1, 'Mã nhóm là bắt buộc'),
  ten_phan_nhom: z.string().min(1, 'Tên nhóm là bắt buộc'),
  ten2: z.string().optional().nullable(),
  trang_thai: z.string().default('1')
});

export type ItemGroupFormValues = z.infer<typeof itemGroupSchema>;

/**
 * Initial values for item group form
 */
export const initialFormValues: ItemGroupFormValues = {
  ma_nhom: '',
  ten_phan_nhom: '',
  ten2: '',
  trang_thai: '1'
};

/**
 * Schema for item group detail
 */
export const itemGroupDetailSchema = z.object({
  ma_nhom: z.string().min(1, 'Mã nhóm là bắt buộc'),
  ten_phan_nhom: z.string().min(1, 'Tên phân nhóm là bắt buộc'),
  ten2: z.string().optional().nullable(),
  trang_thai: z.string().default('active')
});

export type ItemGroupDetailFormValues = z.infer<typeof itemGroupDetailSchema>;
